import React, { useCallback, useMemo } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  Button,
  ModalHeader,
  ModalOverlay,
  Box,
} from "@chakra-ui/react";
import { Col, Row } from "react-bootstrap";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import {  useSelector } from "react-redux";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import SpentAmountTable from "./dataChangeTable/spentAmount";
import GstAmountTable from "./dataChangeTable/gstAmountTable";
import RefundAmountTable from "./dataChangeTable/refundAmountTable";
import TdsAmountTable from "./dataChangeTable/tdsTable";
import ReimbursementAmountTable from "./dataChangeTable/reimbursementTable";

const ExpenseDataChangeModal = ({
  openModal,
  closeModal,
  editData,
  currentData,
  isConfirmed,
  role,
  moduleTyp
}) => {
  const vendorList = useSelector((state) => state.vendorData);
  const clientList = useSelector((state) => state.clientData);
  const getcurrectData = Object.fromEntries(
    Array.from(currentData?.entries() || []).map(([key, value]) => [
      key,
      key === "payInfo" ? JSON.parse(value) : value,
    ])
  );

 
  const currentSpentInfo = useMemo(() => {
    if (getcurrectData?.payInfo) {
      return getcurrectData.payInfo.map(item => item);
    }
    return [];
  }, [getcurrectData]);

  const editSpentInfo = useMemo(() => {
    if (editData?.pyInfo?.list) {
      const currSpentData = getcurrectData?.payInfo || [];
      const spentData = editData.pyInfo.list || [];
      const dummObjectCount = currSpentData.length - spentData.length;

      return [
        ...spentData,
        ...Array(Math.max(0, dummObjectCount)).fill({}),
      ];
    }
    return [];
  }, [getcurrectData, editData]);

  const currentRefundInfo = useMemo(() => {
    if (getcurrectData?.refundInfo) {
      const refundData = JSON.parse(getcurrectData.refundInfo) || [];
      return refundData.map(item => item);
    }
    return [];
  }, [getcurrectData]);

  const editRefundInfo = useMemo(() => {
    if (editData?.rfdInfo?.list) {
      const refundData = editData.rfdInfo.list || [];
      const currrefundData = JSON.parse(getcurrectData?.refundInfo || '[]') || [];
      const dummObjectCount = currrefundData.length - refundData.length;

      return [
        ...refundData,
        ...Array(Math.max(0, dummObjectCount)).fill({}),
      ];
    }
    return [];
  }, [getcurrectData, editData]);


    const currentGstInfo = useMemo(() => {
      if (getcurrectData?.gstInfo) {
        const gstData = JSON.parse(getcurrectData.gstInfo) || [];
        return gstData.map((item) => {
          if (item?.gstFullData && item?.gstFullData?.bsAmt) {
            return item.gstFullData;
          } else if (item?._id && item?._id?.bsAmt) {
            return item._id;
          }
          return null; 
        }).filter(Boolean); 
      }
      return [];
    }, [getcurrectData]);

    const editGstInfo = useMemo(() => {
      if (editData?.gstApl?.gstId) {
        const gstData = editData.gstApl.gstId || [];
        const currgstData = getcurrectData?.gstInfo ? JSON.parse(getcurrectData.gstInfo) : [];
        const dummObjectCount = currgstData.length - gstData.length;
  
        return [
          ...gstData
            .filter(item => item?._id?.bsAmt)
            .map(item => item._id),
          ...Array(dummObjectCount).fill({
            bsAmt: "",
            vId: null,
            gstNo: "",
            prc: 0,
            amt: {
              c: "",
              s: "",
              i: ""
            },
          })
        ];
      }
      return [];
    }, [editData, getcurrectData]);

    const currentTdsInfo = useMemo(() => {
      if (getcurrectData?.tdsInfo) {
        const tdsData = JSON.parse(getcurrectData.tdsInfo) || [];
        return tdsData;
      }
      else{

        return []
      }
    }, [getcurrectData]);

    const editTdsInfo = useMemo(() => {
      if (editData?.tdsApl?.list) {
        const tdsData = editData.tdsApl.list || [];
        const currtdsData = getcurrectData?.tdsInfo ? JSON.parse(getcurrectData.tdsInfo) : [];
        const dummObjectCount = currtdsData.length - tdsData.length;
  
        return [
          ...tdsData
            .filter(item => item?.bsAmt),
          ...Array(dummObjectCount).fill({
            bsAmt: "", 
            prc: 0,
            tlAmt:0,
          })
        ];
      }
      return [];
    }, [editData, getcurrectData]);

  const fetchMerchantName = useCallback((companyId) => 
    vendorList.find(vendor => vendor.isV && vendor._id === companyId)?.name || "", 
    [vendorList]
  );
  
  const fetchClientName = useCallback((clientId) => 
    clientList.find(client => client._id === clientId)?.clName || "", 
    [clientList]
  );

  const fetchProjectName = useCallback((clientId, projectId) => {
    const client = clientList.find((client) => client._id === clientId);
    return client?.prjs?.find((project) => project._id === projectId)?.prj || '';
  }, [clientList]);
  

  return (
    <>
      <Modal
        isOpen={openModal}
        onClose={closeModal}
        size="xl"
        className="modal-main data-change-model"
        scrollBehavior={"inside"}
        
      >
        <ModalOverlay />
        <ModalContent 
         top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
        className="data-change-content info-model"
>
          <ModalHeader className="expense-modal-header data-change-modal-header">
            <>
              {/* Compare fields */}
              <Row className="modal-header-row">
                <Col>
                  <h6>
                    Current
                  </h6>
                </Col>
                
                <Col>
                  <h6 >
                    Edited
                  </h6>
                </Col>
              </Row>
            </>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody className="mt-0">
            <Row>
              <Col className="row-col">
                <div className="row-table">
                  <Row className="rowC">
                        <h4 className="row-heading">
                          Purchase Order Details :
                        </h4>
                      </Row>
                  <Row className="rowC">
                    <Col>
                      Order Month : {dateTimeFormat(editData.oM)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                    <Col>Order Date : {dateTimeFormat(editData.oDt)}</Col>
                  </Row>

                
                 
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Expense :
                        </h4>
                      </Row>
                      
                      <Row className="rowC">
                        <Col className={`${editData?.mjId?._id !== getcurrectData.majorId  ? 'data_compare_red' : '' }`}>Major Type : {editData.mjId?.val}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.mnId?._id !== getcurrectData.minorId  ? 'data_compare_red' : '' }`}>Minor Type : {editData?.mnId?.val}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.msId?._id !== getcurrectData.minorSubCategoryId  ? 'data_compare_red' : '' }`}>Minor Sub Category : {editData?.msId?.val}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.mrId?._id !== getcurrectData.merchantId  ? 'data_compare_red' : '' }`}>Merchant Name : {fetchMerchantName(editData?.mrId?._id)}</Col>
                      </Row>
                      {moduleTyp !== 'Internal' &&
                      <>
                      <Row className="rowC">
                        <Col className={`${editData?.clId?._id !== getcurrectData.clientName  ? 'data_compare_red' : '' }`}>Client Name : {fetchClientName(editData.clId?._id)}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData.prId?._id !== getcurrectData.projectName  ? 'data_compare_red' : '' }`}>Project Name : {fetchProjectName(editData.clId?._id,editData.prId?._id)}</Col>
                      </Row>
                      </>
                      }
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_red' : '' }`}>Remarks : {editData.rmks}</Col>
                      </Row>

                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Freight Expense: 
                        </h4>
                      </Row>
                    <Row className="rowC">
                    <Col className={`${editData?.exp?.adId?._id !== getcurrectData?.agencyId  ? 'data_compare_red' : '' }`}> Agency : {editData?.exp?.adId?.val}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.exp?.trkNo !== getcurrectData?.trackingNum  ? 'data_compare_red' : '' }`}> Tracking Num : {editData?.exp?.trkNo}</Col>
                      </Row>

                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information : 
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.approvalAmount || 0)  ? 'data_compare_red' : '' }`}>
                            <Box display="flex">
                            Requested Amount : {formatAmountInINR(editData?.pyInfo?.apAmt)}
                            </Box>
                        </Col>
                      </Row>

                     <SpentAmountTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="current" />
                 
                  {(role === "Manager" || role === "Admin") &&
                 
                  <>
                    <Row className="rowC">
                          <h4
                            className="row-heading"
                          >
                            TDS Applicable :
                          </h4>
                        </Row>
                        <TdsAmountTable editTdsData={editTdsInfo} currentTdsData={currentTdsInfo} type="current" />

                 
                  
                  <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          GST Information : 
                        </h4>
                      </Row>
                      <GstAmountTable editGstInfo={editGstInfo} currentGstInfo={currentGstInfo} type="current"/>

                     

                      <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="current"/>

                  
                   
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Reimbursement Information
                        </h4>
                      </Row>
                     
                      <ReimbursementAmountTable editReimbursementInfo={editData} currentReimbursementInfo={getcurrectData} type="current"/>

                    </>
}
                  
                   
                </div>
              </Col>
              <Col className="row-col">
                <div className="row-table">
                <Row className="rowC">
                        <h4
                         className="row-heading"
                        >
                          Purchase Order Details :
                        </h4>
                      </Row>
                  <Row className="rowC">
                    <Col>
                      Order Month : {dateTimeFormat(getcurrectData.orderMonth)}
                    </Col>
                  </Row>
                  <Row className="rowC">
                    <Col>
                      Order Date : {dateTimeFormat(getcurrectData.orderDate)}
                    </Col>
                  </Row>
                  
                  
                  
                    <>
                     
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Expense :
                        </h4>
                      </Row>
                      

                     
                      
                      <Row className="rowC">
                        <Col className={`${editData?.mjId?._id !== getcurrectData?.majorId  ? 'data_compare_green' : '' }`}>Major Type : {getcurrectData.expenseType}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.mnId?._id !== getcurrectData.minorId  ? 'data_compare_green' : '' }`}>Minor Type : {getcurrectData.minorType}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.msId?._id !== getcurrectData.minorSubCategoryId  ? 'data_compare_green' : '' }`}>Minor Sub Category : {getcurrectData.minorTypeCategory ? getcurrectData.minorTypeCategory : ''}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.mrId?._id !== getcurrectData.merchantId  ? 'data_compare_green' : '' }`}>Merchant Name : {fetchMerchantName(getcurrectData?.merchantId)}</Col>
                      </Row>
                      {moduleTyp !== 'Internal' &&
                      <>
                      <Row className="rowC">
                        <Col className={`${editData?.clId?._id !== getcurrectData.clientName  ? 'data_compare_green' : '' }`}>Client Name : {fetchClientName(getcurrectData.clientName)}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.prId?._id !== getcurrectData.projectName  ? 'data_compare_green' : '' }`}>Project Name : {fetchProjectName(getcurrectData.clientName,getcurrectData.projectName)}</Col>
                      </Row>
                      </>
                      } 
                      <Row className="rowC">
                        <Col className={`${editData.rmks !== getcurrectData.remarks  ? 'data_compare_green' : '' }`}>Remarks : {getcurrectData.remarks}</Col>
                      </Row>
                      
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Freight Expense: 
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.exp?.adId?._id !== getcurrectData?.agencyId  ? 'data_compare_green' : '' }`}>Agency : {getcurrectData?.agency}</Col>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${editData?.exp?.trkNo !== getcurrectData?.trackingNum  ? 'data_compare_green' : '' }`}>Tracking Num : {getcurrectData?.trackingNum}</Col>
                      </Row>

                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Payment Information :
                        </h4>
                      </Row>
                      <Row className="rowC">
                        <Col className={`${Number(editData?.pyInfo?.apAmt || 0) !== Number(getcurrectData?.approvalAmount || 0)  ? 'data_compare_green' : '' }`}>
                        <Box display="flex">

                        Requested Amount : {formatAmountInINR(parseFloat(getcurrectData?.approvalAmount))}
                        </Box>
                        </Col>
                      </Row>
                       
                    </>
                  
                    <SpentAmountTable editSpentInfo={editSpentInfo} currentSpentInfo={currentSpentInfo} type="edited" />
                 
              
                 
                    {(role === "Manager" || role === "Admin") &&
                    <>
                  <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          TDS Applicable :
                        </h4>
                      </Row>
                      <TdsAmountTable editTdsData={editTdsInfo} currentTdsData={currentTdsInfo} type="edited" />

                 
                  
               
                  <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          GST Information : 
                        </h4>
                      </Row>
                      <GstAmountTable editGstInfo={editGstInfo} currentGstInfo={currentGstInfo} type="edited"/>


                 
                      <Row className="rowC">
                        <h4
                          className="row-heading" 
                        >
                          Refund Information : 
                        </h4>
                      </Row>
                      <RefundAmountTable editRefundInfo={editRefundInfo} currentRefundInfo={currentRefundInfo} type="edited"/>
                  
                    
                      <Row className="rowC">
                        <h4
                          className="row-heading"
                        >
                          Reimbursement Information :
                        </h4>
                      </Row>
                      <ReimbursementAmountTable editReimbursementInfo={editData} currentReimbursementInfo={getcurrectData} type="edited"/>

                      
                    </>
                    }
                   
                 
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="border-2 p-0 pt-4 pb-2">
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                isConfirmed();
                closeModal();
              }}
            >
              ok
            </Button>
            <Button
              type="submit"
              className="submit-btn"
              variant="brand"
              style={{ background: "#191063", minWidth: "100px" }}
              onClick={() => {
                closeModal();
              }}
            >
              cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ExpenseDataChangeModal;
